import { useState } from "react";

export const AdditionalNoteEntries = ({
  disabled = false,
  item,
  onAdd,
  onUpdate,
}) => {
  const [message, setMessage] = useState("");
  const [editingId, setEditingId] = useState("");
  const [editingMessage, setEditingMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const entries = item.additional_note_entries || [];

  const add = async () => {
    if (!message.trim()) {
      return;
    }
    setIsSubmitting(true);
    const updated = await onAdd(item.id, message.trim());
    setIsSubmitting(false);
    if (updated) {
      setMessage("");
    }
  };

  const save = async (entryId) => {
    if (!editingMessage.trim()) {
      return;
    }
    setIsSubmitting(true);
    const updated = await onUpdate(item.id, entryId, editingMessage.trim());
    setIsSubmitting(false);
    if (updated) {
      setEditingId("");
      setEditingMessage("");
    }
  };

  return (
    <section data-testid={`additional-note-entries-${item.id}`}>
      <h3>Additional Notes</h3>
      {item.additional_notes && (
        <p data-testid={`legacy-additional-note-${item.id}`}>
          Legacy Additional Note · {item.additional_notes}
        </p>
      )}
      {entries.map((entry) => (
        <article data-testid={`additional-note-entry-${entry.id}`} key={entry.id}>
          {editingId === entry.id ? (
            <>
              <textarea
                data-testid={`additional-note-edit-input-${entry.id}`}
                onChange={(event) => setEditingMessage(event.target.value)}
                value={editingMessage}
              />
              <button
                data-testid={`additional-note-edit-save-${entry.id}`}
                disabled={isSubmitting}
                onClick={() => save(entry.id)}
                type="button"
              >
                Save
              </button>
              <button
                data-testid={`additional-note-edit-cancel-${entry.id}`}
                disabled={isSubmitting}
                onClick={() => setEditingId("")}
                type="button"
              >
                Cancel
              </button>
            </>
          ) : (
            <>
              <p>{entry.message}</p>
              <small>
                {entry.author_name_snapshot || "Unknown"} · {entry.created_at || ""}
              </small>
              {!disabled && entry.can_edit && (
                <button
                  data-testid={`additional-note-edit-${entry.id}`}
                  onClick={() => {
                    setEditingId(entry.id);
                    setEditingMessage(entry.message || "");
                  }}
                  type="button"
                >
                  Edit
                </button>
              )}
            </>
          )}
        </article>
      ))}
      {!disabled && item.can_add_additional_note && (
        <div>
          <textarea
            data-testid={`additional-note-create-input-${item.id}`}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Add context or follow-up"
            value={message}
          />
          <button
            data-testid={`additional-note-create-${item.id}`}
            disabled={isSubmitting || !message.trim()}
            onClick={add}
            type="button"
          >
            Add Note
          </button>
        </div>
      )}
    </section>
  );
};